import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import '../../styles/modals/ConfirmationFeedDeleteModal.css'
import { useTranslation } from 'react-i18next'
import { ReactComponent as SuccessIconFrame } from '../../assets/svg/SuccessIconFrame.svg'
import { ReactComponent as SuccessStudentTransferIcon } from '../../assets/svg/SuccessStudentTransferIcon.svg'
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg'
import Loading from '../Loading'

function SuccessStudentTransferModal({ modalIsOpen, afterOpenModal, closeModal, data, confirmation, message, subMessage = '' }) {
    const { t, locale } = useTranslation()

    const [progress, setProgress] = useState(false)

    useEffect(() => {
        if (modalIsOpen) {
            Modal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalIsOpen])

    const submitConfirm = () => {
        confirmation()
        // closeModal();
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            contentLabel="Example Modal"
            onAfterClose={() => {
                setProgress(false)
            }}
            style={{
                overlay: {
                    zIndex: 102,
                },
                content: {
                    width: 650,
                    padding: 0,
                    opacity: 1,
                    minWidth: 650,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '90%',
                    border: 'none',
                    margin: 'auto',
                    boxShadow: 'none',
                    overflow: 'hidden',
                },
            }}
        >
            <div className="absolute top-0 w-full flex items-center justify-center ">
                <div
                    className="w-[60px] h-[60px] bg-deepPurple rounded-full cursor-pointer flex items-center justify-center z-[2] hover:bg-darkenPurple "
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        closeModal()
                    }}
                >
                    <CloseModalIcon />
                </div>
            </div>
            <div className="bg-whiteContrast rounded-xl flex flex-col  items-center justify-between p-10 mt-[30px]">
                <p className="text-deepPurple text-[32px] leading-[42px] font-bold text-center max-w-[360px] flex-wrap" id="transfer-success-modal-message">
                    {message}
                </p>
                <p className="text-deepPurple text-[14px] leading-[17px] font-medium -mb-10">{subMessage}</p>
                <div className="-mb-14 z-[2]">
                    <SuccessStudentTransferIcon />
                </div>
                <div className="w-full flex flex-col gap-[25px] rounded-[10px] p-10 bg-white ">
                    <p className="text-deepPurple text-[18px] leading-[20px] font-semibold">
                        {t('student')}:
                        <span className="text-darkenPurple font-bold ml-[10px] ">
                            {data?.student?.first_name} {data?.student?.last_name}
                        </span>
                    </p>
                    <div className=" flex flex-row items-center gap-[30px]">
                        <p className="text-deselectPurple text-[18px] leading-[20px] font-semibold">
                            {t('Old class')}:<span className="text-mudPurple font-bold ml-[10px] ">{data?.oldClass?.name}</span>
                        </p>
                        <p className="text-deepPurple text-[18px] leading-[20px] font-semibold">
                            {t('New class')}:<span className="text-darkenPurple font-bold ml-[10px] ">{data?.class?.name}</span>
                        </p>
                    </div>
                </div>

                <div className="flex flex-row justify-center  items-center w-full mt-10">
                    <button
                        className="bg-deepPurple cursor-pointer flex flex-row items-center justify-center   rounded-full  px-[25px] min-w-[250px] h-[50px]"
                        onClick={() => closeModal()}
                        id="close-success-modal-button"
                    >
                        <p className="text-white text-[18px] leading-[23px] font-semibold">{t('close')}</p>
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default SuccessStudentTransferModal
